import { sortBy } from 'lodash';

const ReportDataMapper = {
  mapFdaPracticeArea: pa => ({
    practice: getPracticeName(pa),
    hoveringText: getHoveringText(pa),
    trend: pa.Trend,
    satisfiedPercentage: pa.SatisfiedPercentage,
    aggregatePercentage: pa.AggregatePercentage,
    count: pa.Count
  }),

  mapFdaDeltaPracticeArea: pa => {
    const [firstInstanceData, secondInstanceData] = sortBy(
      pa.InstanceEvaluationDetails,
      x => x.Instance
    );

    return {
      practice: getPracticeName(pa),
      hoveringText: getHoveringText(pa),
      trend: pa.Trend,
      firstInstanceSatisfiedPercentage: firstInstanceData.SatisfiedPercentage,
      secondInstanceSatisfiedPercentage: secondInstanceData.SatisfiedPercentage,
      firstInstanceAggregatePercentage: firstInstanceData.AggregatePercentage,
      secondInstanceAggregatePercentage: secondInstanceData.AggregatePercentage,
      deltaSatisfied: pa.DeltaSatisfied,
      deltaAggregate: pa.DeltaAggregate,
      firstInstanceCount: firstInstanceData.Count,
      secondInstanceCount: secondInstanceData.Count
    };
  }
};

const getPracticeName = pa => pa.Acronym + ' ' + pa.GroupLevel + '.' + pa.NumberWithinLevel;
const getHoveringText = pa => pa.Name + ': ' + pa.Practice.Name;

export default ReportDataMapper;
